import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface ContactUsTransferState {
  message?: string;
}

const initialState: ContactUsTransferState = {
  message: undefined,
};

const contactUsTransferSlice = createSlice({
  initialState,
  name: 'contact-us-transfer',
  reducers: {
    clearContactUsTransfer: () => ({
      ...initialState,
    }),
    setContactUsTransfer: (
      state,
      action: PayloadAction<ContactUsTransferState>
    ) => ({
      ...state,
      message: action.payload.message,
    }),
  },
});

export const contactUsTransferSelector = (state) => state.contactUsTransfer;

export const { setContactUsTransfer, clearContactUsTransfer } =
  contactUsTransferSlice.actions;

export default contactUsTransferSlice.reducer;
